// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".bar-list[data-v-7d8b39d7] {\n  margin-bottom: 25px;\n}\n.bar-list .chart-bar[data-v-7d8b39d7] {\n  height: 280px;\n  width: 100%;\n}", ""]);
// Exports
module.exports = exports;
